import { render, staticRenderFns } from "./ListarAtestados.vue?vue&type=template&id=08e1adff&"
import script from "./ListarAtestados.vue?vue&type=script&lang=js&"
export * from "./ListarAtestados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports